export const IN_PLAY_ROUTE = {
  TITLE: 'In Play',
  ABSOLUTE_PATH: '/in-play',
  EXACT_PATH: '/in-play',
};
